module.exports = __webpack_public_path__ + "static/img/03.00fdfc1a.png";